import { saveAs } from "file-saver";
import Papa from "papaparse";

export const convertToCsv = (title, { data, fields }) => {
  const headerCsv = Papa.unparse({ fields, data: [] });
  const dataCsv = Papa.unparse(data, { header: false });
  const csv = headerCsv + dataCsv;
  const blob = new Blob([csv], { type: "application/csv" });
  saveAs(blob, generateFileName(title));
};

export const convertFromCsv = (file) => {
  return new Promise((resolve, reject) => {
    Papa.parse(file, {
      header: true,
      complete: resolve,
      error: reject,
    });
  });
};

const generateFileName = (title) => {
  const dateString = new Date().toISOString().slice(0, 19).replace("T", "@");
  return `${title}_${dateString}.csv`;
};
